import React from "react"
import { useMatch } from "react-router"
import { useLocation, useNavigate } from "react-router-dom"
import { Icon } from "semantic-ui-react"
import BifrostButton from "../../../Components/BifrostElementComponent/BifrostButton/BifrostButton"
import "../../Pages.scss"
import "./MainPanelHeader.scss"

const MainPanelHeader = ({ title, name, userLimitItem, children, navPath }) => {
	const nav = useNavigate()
	const { state: lastState } = useLocation()
	const match = useMatch("/activity")

	const handleButtonClick = () => {
		if (lastState && lastState.lastPath && !lastState.tab) {
			nav(lastState.lastPath, { state: { name: lastState.name, tab: null } })
		} else if (lastState && lastState.tab && lastState.lastPath) {
			nav(lastState.lastPath, { state: { name: lastState.name, tab: lastState.tab } })
		} else {
			nav(navPath)
		}
	}

	return (
		<section className={"main-panel-header"}>
			<nav className={"table"}>
				<h1 className={"table-cell"} style={{ alignItems: "center" }}>
					{name && !match ? (
						<>
							<BifrostButton
								size="huge"
								style={{
									display: "inline-block",
									backgroundColor: "inherit",
									color: "black",
									marginBottom: "1px",
									padding: 0
								}}
								onClick={handleButtonClick}
							>
								<Icon name="chevron left" />
							</BifrostButton>
							{name}
						</>
					) : (
						<div className="user-title">
							{title}
							{userLimitItem && <div>{userLimitItem}</div>}
						</div>
					)}
				</h1>
			</nav>
			<div className="main-panel-header-create-modal">{title && <nav className={"modal-button"}>{children}</nav>}</div>
		</section>
	)
}

export default MainPanelHeader
